
<template>
    <div class="mian">
        <div class="banner">
            <img class="banner-img" :src="'https://cdn.zxzx119.com/zxzx-h5/activity/homeEmergency/banner.png?date='+date" alt="" srcset="">
        </div>
        <div class="content">
            <img class="content-img" style="padding: 0 20px;" :src="'https://cdn.zxzx119.com/zxzx-h5/activity/homeEmergency/img1.png?date='+date" alt="" srcset="">
            <div class="comm">
                <img class="comm-img" :src="'https://cdn.zxzx119.com/zxzx-h5/activity/homeEmergency/img2.png?date='+date" alt="" srcset="">
                <img class="comm-btn" @click="postMsg(14013)" :src="'https://cdn.zxzx119.com/zxzx-h5/activity/homeEmergency/btn.png?date='+date" alt="" srcset="">
            </div>
            <div class="comm comm2" style="padding-bottom: 30px;">
                <img class="comm-img" :src="'https://cdn.zxzx119.com/zxzx-h5/activity/homeEmergency/img3.png?date='+date" alt="" srcset="">
                <img class="comm-btn" @click="postMsg(14014)" :src="'https://cdn.zxzx119.com/zxzx-h5/activity/homeEmergency/btn.png?date='+date" alt="" srcset="">
            </div>
        </div>
        
    </div>
</template>
<script>
import wxShare from '../../../wx/weixin.js'
export default {
    name:'',
    components: {
    },
    data () {
        return {
            isApp: 0, // 0: h5  1/2 : app  3: 小程序
             date :"",
        }
    },
    created () {
        this.isApp = parseInt(this.$route.query.isApp) ? parseInt(this.$route.query.isApp) : 0;
         this.init()
    },
    methods: {
        postMsg(num) {
            console.log("isApp:", this.isApp)
            if (this.isApp == 3) {
                uni.navigateTo({//redirectTo
                    url : "/pages/goods-detail/goods-detail?goodId="+num,
                })
            } else if (this.isApp == 0) {//h5
                this.$router.push({
                    path: '/goodsdetail',
                    query: {
                        goodsId: num,
                        businessId: 26359
                    }
                    })
            } else if (this.isApp == 1||this.isApp == 2) {
                if (this.utils.isIphone()) { // ios 
                    window.webkit.messageHandlers.toShopInfoPage.postMessage({supplierId : '26359','goodsId': num+''})
                } else {
                    window.zxzx.toShopInfoPage(26359,num)
                }
            }
        },  
        init() {
             var userAgent = navigator.userAgent;
            let imgUrl = 'https://cdn.zxzx119.com/zxzx-h5/activity/homeEmergency/share.png'
            wxShare.wxRegister('沁夏随行包', '', imgUrl)
        }
    },
    mounted () {
        this.date = new Date().getTime()
        console.log(this.date)
        this.$nextTick(() => {
            document.addEventListener("UniAppJSBridgeReady", function () {
                uni.getEnv(function(res) {
                    // console.log('当前环境：' + JSON.stringify(res));
                });
            })
        })
    },
}

</script>


<style lang='scss' scoped>
.mian{
    background: url(https://cdn.zxzx119.com/zxzx-h5/activity/homeEmergency/bj.png);
}
.banner{
    width: 100%;
    .banner-img{
        width: 100%;
        height: 100%;
    }

}
.content{
    text-align: center;
     padding: 0 5px;
    .comm{
        width: 100%;
        margin-top: 25px;
        position: relative;
        padding: 0 20px;
        .comm-img{
            width: 100%;
        }
        .comm-btn{
            position: absolute;
            top: 100px;
            right: 3%;
            transform: translate(-50%,-50%);
            width: 90px;

        }
    }
    .comm2{
         .comm-btn{
            position: absolute;
            top: 120px;
            transform: translate(-50%,-50%);
            width: 90px;
        }
    }
    .content-img{
        width: 100%;
    }
    .content-btn{
        width: 125px;
    }
}

</style>


// WEBPACK FOOTER //
// src/view/activity/homeEmergency/index-h5.vue